<template lang="html">
  <div class="form-control"
    :class="[classes, {'is-read-only': readOnly, 'is-error': errors.length}]">
    <div class="field-wrapper">
      <label
        class="label"
        v-if="label">
          {{label}}
      </label>
      <Tooltip
        v-if="tooltip"
        :tooltipText="tooltip"/>
      <div class="wrapper">
        <span class="is-optional" v-if="optional"> {{ $t('components.input.optional') }}</span>
        <textarea ref="field" class="form-field"
            :name="name"
            :id="name"
            :value="value"
            @input="$emit('input', $event.target.value)"></textarea>
          <span v-if="information && !errors.length">{{ information }}</span>
          <template v-for="error in errors">
            <span class="error-information">{{ error }}</span>
          </template>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'VqTextarea',
  props: {
    label: String,
    name: String,
    classes: String,
    value: {
      type: [String, Number],
      default: '',
    },
    information: String,
    model: Object,
    tooltip: {
      type: String,
      required: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default() { return []; },
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style scoped lang="scss">
</style>
